import React, { Component, useRef} from 'react';
import { useState, useEffect } from 'react';
import '../../App.css'
import { Popup, Marker, Tooltip, useMapEvents } from 'react-leaflet'
import { KOREATOWN_LOGO_URL_PREFIX } from "../../Config";
import { getTextWorkCityDe } from "../../component/common/BaseUtil"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faLocationDot } from '@fortawesome/free-solid-svg-icons';

export function CustomMarker(props) {
    const popupRef = useRef();

    const [currentZoomLevel, setcurrentZoomLevel] = useState(props.object.currentZoomLevel);
    const position = [Number(props.object.latitude), Number(props.object.longitude)];

    const koreaTownFileEntity = props.object.koreaTownFileEntitySet[0]
    //const fileDirectory = koreaTownFileEntity ? props.object.koreaTownFileEntitySet[0].fileDirectory : ""
    const fileName = koreaTownFileEntity ? props.object.koreaTownFileEntitySet[0].koreatownUniqFileName : ""
    const koreatownFileFormat = koreaTownFileEntity ? props.object.koreaTownFileEntitySet[0].koreatownFileFormat : ""
    //const main_img_url = KOREATOWN_LOGO_URL_PREFIX + fileDirectory + "/" + fileName + "." + koreatownFileFormat
    const main_img_url = KOREATOWN_LOGO_URL_PREFIX + fileName + "." + koreatownFileFormat

    const closePopup = () => {
      console.log("call closePopup")
      if (popupRef.current) {
        popupRef.current.close(); // 팝업의 close 메서드 호출
      }
    };

    function clickHomepageBtn(){
        window.open(props.object.homepage, "_blank");
    }

    function clickMenuBtn(){
        window.open(props.object.menu, "_blank");
    }

    function clickOnlineOrderBtn(){
        window.open(props.object.onlineOrder, "_blank");
    }

    function clickReservationBtn(){
        window.open(props.object.reservation, "_blank");
    }

    const map = useMapEvents({
    // 맵이 처음 로드될 때 한 번 실행됩니다.
    load: () => {
      const initialZoom = map.getZoom();
      console.log('🗺️ Map Loaded! Initial zoom level:', initialZoom);
    },
    // 줌 변경 애니메이션이 끝날 때마다 실행됩니다.
    zoomend: () => {
      const newZoom = map.getZoom(); // 맵 인스턴스에서 현재 줌 레벨을 가져옵니다.
      console.log('🔍 Zoom Ended! New zoom level:', newZoom);
      props.handleLevel(newZoom)
    },
  });

   useEffect(() => {
        setcurrentZoomLevel(props.currentZoomLevel)
        closePopup()
    }, [props.centerPosition, props.currentZoomLevel]);

    // 줌 레벨에 따라 어떤 툴팁을 렌더링할지 결정
    let tooltipToRender;
    if (props.currentZoomLevel < 13) {
      // 줌아웃 상태: 더 넓게 보일 때 영구적인 툴팁
      tooltipToRender = "";
    } else {
      // 줌인 상태: 더 자세히 보일 때 마우스 오버 툴팁
      tooltipToRender = (
        <Tooltip permanent={true} direction="right">
          {props.object.storeNameKo}
        </Tooltip>
      );
    }

    return <Marker position={position}>
            {tooltipToRender}
            <Popup minWidth={300} maxWidth={360} ref={popupRef}>
              <div class="card" style={{width: '100%', maxWidth: '300px', border: 'none', height:'auto'}}>
                  <div class="card-body">
                    {koreaTownFileEntity && (
                      <CustomCarousel main_img_url={main_img_url} />
                    )}
                    <h5 class="card-title">{props.object.storeNameKo}</h5>
                    <p class="card-text">
                      <FontAwesomeIcon icon={faLocationDot}/>  {props.object.street + " " + props.object.streetNumber + ", " + props.object.zipCode + " " + getTextWorkCityDe(props.cityList, props.object.cityId)}<br/>
                      <FontAwesomeIcon icon={faPhone}/> {props.object.telno}
                    </p>
                    {/* <p class="card-text">{props.object.telno}</p> */}
                    {props.object.homepage && props.object.homepage.trim() !== '' && (
                      <a href="#" class="btn btn-outline-secondary btn-sm" style={{marginRight:"5px", marginBottom:"5px"}} onClick={clickHomepageBtn}>홈페이지</a>
                    )}
                    {props.object.menu && props.object.menu.trim() !== '' && (
                      <a href="#" class="btn btn-outline-secondary btn-sm" style={{marginRight:"5px", marginBottom:"5px"}} onClick={clickMenuBtn}>메뉴보기</a>
                    )}
                    {props.object.onlineOrder && props.object.onlineOrder.trim() !== '' && (
                      <a href="#" class="btn btn-outline-secondary btn-sm" style={{marginRight:"5px", marginBottom:"5px"}} onClick={clickOnlineOrderBtn}>온라인주문</a>
                    )}
                    {props.object.reservation && props.object.reservation.trim() !== '' && (
                      <a href="#" class="btn btn-outline-secondary btn-sm" style={{marginRight:"5px", marginBottom:"5px"}} onClick={clickReservationBtn}>예약하기</a>
                    )}
                  </div>
              </div>
            </Popup>
        </Marker>
}

export function CustomCarousel(props) {
    return (
        <div id="carouselControls" style={{marginBottom:"10px"}} className="koreatown-popup-img" class="carousel slide" data-ride="carousel">
          <div class="carousel-inner">
            <div class="carousel-item active">
              <img class="d-block w-100 rounded" src={props.main_img_url} alt="main image"/>
            </div>
          </div>
        </div>
    );
}